import React from 'react';
import SecurityFormHeader from './components/Header/SecurityFormHeader';
import styled from 'styled-components';
import TwoStepAuthentication from './components/TwoStepAuthentication/TwoStepAuthentication';

const SecurityForm = () => (
    <StyledSecurityForm>
        <SecurityFormHeader />
        <TwoStepAuthentication />
    </StyledSecurityForm>
);

export default SecurityForm;

const StyledSecurityForm = styled.section`
    margin-top: 64px;
`;
